import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=b14d8d14&scoped=true"
import script from "./PublishButton.vue?vue&type=script&lang=ts"
export * from "./PublishButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14d8d14",
  null
  
)

export default component.exports